import { CanceledTransfer, ScheduledTransfer } from "@assets";
import { ShareGoalInviteStatus as InviteStatus } from "@ctypes";
import { i18n, Translations } from "@i18n";

export const label: Record<InviteStatus, string> = {
  [InviteStatus.Accepted]: i18n.t(Translations.InviteItemAcceptedLabel),
  [InviteStatus.Expired]: i18n.t(Translations.InviteItemExpiredLabel),
  [InviteStatus.Pending]: i18n.t(Translations.InviteItemPendingLabel),
  [InviteStatus.Rejected]: i18n.t(Translations.InviteItemDeniedLabel),
};

export const icon: Record<InviteStatus, any> = {
  [InviteStatus.Accepted]: <ScheduledTransfer />,
  [InviteStatus.Expired]: <ScheduledTransfer />,
  [InviteStatus.Pending]: <ScheduledTransfer />,
  [InviteStatus.Rejected]: <CanceledTransfer />,
};
